import axios from 'axios'
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

import WillentlichesVergessenApp from './components/WillentlichesVergessenApp'

import Game from "./components/Game";
import Intro from "./components/Intro";
import Video from "./components/Video";

window.appStandbyTime = 360000;
window.dataPath = 'data/';

const router = new VueRouter({
  routes: [
    { path: '*', redirect: to => { return "/Intro/1" }},   
    { path: '/Game/:level', component: Game },
    { path: '/Intro/:page', component: Intro },
    { path: '/Intro', redirect: to => { return "/Intro/1" } },     
    { path: '/Video', component: Video },
  ],
});
  
var vue = new Vue({
  el: '#app',
  router: router,
  render: h => h(WillentlichesVergessenApp)
});


// WEBPACK FOOTER //
// ./src/main.js